import Card from "react-bootstrap/Card";
import Logo from "../assets/logo.png";
import CyberSecurity from "../assets/cybersecurity.png";
import DataAnalytics from "../assets/dataanalytics.png";
import EnterpriseSystem from "../assets/enterprisesystem.png";
import TechInnovation from "../assets/techinnovation.png";

import axios from "axios";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import {
  Button,
} from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';

function HomeScreen() {
  // const [showSubCards, setShowSubCards] = useState(false);
  const [subCardData, setSubCardsData] = useState([]);
  // const [cards, setCards] = useState([]);
  const [courses, setCourses] = useState([]);
  const [algs, setAlgs] = useState([]);
  const [coordinators, setCoordinators] = useState([]);
  const [resources, setResources] = useState([]);
  const [permSchedules, setPermSchedules] = useState([]);
  const [courseRelatedData, setCourseRelatedData] = useState();
  const [finalizedCardsContent, setFinalizedCardsContent] = useState([]);
  const [hideMainContent, setHideMainContent] = useState(false);
  const requiredCourses = [1114, 3003, 3123, 3203, 3223, 3423, 3883, 4323, 4683, 4723, 4823, 4983];
  const dataAnalysticsAndTechnology = [3703, 4713, 4733, 4773, 4793];
  const cyberOperationsAndSecurity = [4833, 4843, 4853, 4863, 4883, 4893];
  const enterpriseSystems = [3503, 4153, 4403, 4333, 4673];
  const technologyAndInnovation = [4603, 4613, 4623, 4633];

  const [show, setShow] = useState(false);

  useEffect(() => {
    axios
      .get(
        "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/courses"
      )
      .then((response) => {
        // console.log("Course data==>:", response);

        // setCards([...response?.data.courses]);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);
  useEffect(() => {
    axios
      .get(
        "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/courses"
      )
      .then((response) => {
        // console.log("Resource data==>:", response);

        setCourses([...response?.data.courses]);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);
  useEffect(() => {
    axios
      .get(
        "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/resources"
      )
      .then((response) => {
        // console.log("Resource data==>:", response);

        setResources([...response?.data.courses]);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);
  useEffect(() => {
    axios
      .get(
        "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/coordinator"
      )
      .then((response) => {
        // console.log("Resource data==>:", response);

        setCoordinators([...response?.data.courses]);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);
  useEffect(() => {
    axios
      .get(
        "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/alg"
      )
      .then((response) => {
        // console.log("Resource data==>:", response);

        setAlgs([...response?.data.courses]);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);
  useEffect(() => {
    axios
      .get(
        "https://lgl8fzfq6i.execute-api.ap-south-1.amazonaws.com/dev/permSchedules"
      )
      .then((response) => {
        // console.log("Resource data==>:", response);

        setPermSchedules([...response?.data.courses]);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, []);

  const _redirectToSelectedContent = (id) => {
    const modifiedData = courses?.map((item) => ({
      ...item,
      subCardData: [
        {
          name: "",
          description: "",
        },
      ],
      resource: resources.find(o => o.courseNumber === item.courseNumber),
      alg: algs.find(o => o.courseNumber === item.courseNumber),
      coordinator: coordinators.find(o => o.courseNumber === item.courseNumber),
      permSchedule: permSchedules.find(o => o.courseNumber === item.courseNumber)
    }));
    console.log("modifiedData==>", modifiedData);
    // setCards([...response?.data]);
    let filteredData = [];
    if (id === "1")
      filteredData = modifiedData.filter(item => requiredCourses.includes(item.courseNumber));
    if (id === "2")
      filteredData = modifiedData.filter(item => dataAnalysticsAndTechnology.includes(item.courseNumber));
    if (id === "3")
      filteredData = modifiedData.filter(item => cyberOperationsAndSecurity.includes(item.courseNumber));
    if (id === "4")
      filteredData = modifiedData.filter(item => enterpriseSystems.includes(item.courseNumber));
    if (id === "5")
      filteredData = modifiedData.filter(item => technologyAndInnovation.includes(item.courseNumber));
    filteredData.sort((a, b) => a.courseNumber - b.courseNumber);
    setFinalizedCardsContent([...filteredData]);
    setHideMainContent(true);
  };

  const _goBackMainContent = () => {
    setHideMainContent(false);
  };

  return (
    <div className="App" style={{ paddingHorizontal: 25 }}>
      <div style={{ width: "100%" }}>
        {/* <img src={Hero} alt="" style={{ height: 600, width: "100%" }} /> */}
      </div>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          // gap: 50
          marginTop: 42,
        }}
      >
        {
          !hideMainContent ? (<>
            <Card style={{ width: '14rem' }}>
              <Card.Img variant="top" src={Logo} />
              <Card.Body>
                <Card.Title>Required Major Courses</Card.Title>
                <Card.Text>

                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent("1")}>Click Here</Button></Card.Footer>
            </Card>
            <Card style={{ width: '14rem', marginLeft: "1rem" }}>
              <Card.Img variant="top" src={DataAnalytics} />
              <Card.Body>
                <Card.Title>Data Analytics and Technology</Card.Title>
                <Card.Text>

                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent("2")}>Click Here</Button></Card.Footer>
            </Card>
            <Card style={{ width: '14rem', marginLeft: "1rem" }}>
              <Card.Img variant="top" src={CyberSecurity} />
              <Card.Body>
                <Card.Title>Cyber Operations Security</Card.Title>
                <Card.Text>

                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent("3")}>Click Here</Button></Card.Footer>
            </Card>
            <Card style={{ width: '14rem', marginLeft: "1rem" }}>
              <Card.Img variant="top" src={EnterpriseSystem} />
              <Card.Body>
                <Card.Title>Enterprise Systems</Card.Title>
                <Card.Text>

                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent("4")}>Click Here</Button></Card.Footer>
            </Card>
            <Card style={{ width: '14rem', marginLeft: "1rem" }}>
              <Card.Img variant="top" src={TechInnovation} />
              <Card.Body>
                <Card.Title>Technology and Innovation</Card.Title>
                <Card.Text>

                </Card.Text>
                {/* <Button variant="primary">Go somewhere</Button> */}
              </Card.Body>
              <Card.Footer><Button variant="warning" onClick={() => _redirectToSelectedContent("5")}>Click Here</Button></Card.Footer>
            </Card>
          </>
          ) : (
            finalizedCardsContent?.map((course, index) => {
              return (
                <div
                  key={index}
                  style={{
                    padding: 10,
                    gap: 50,
                    width: "33%",
                    // backgroundColor: "red",
                    color: "black",
                    // boxShadow: "10px black",
                  }}
                >
                  <Card>
                    <Card.Body
                      style={{
                        height: "350px",
                      }}
                    >
                      <Card.Title>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 24,

                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          {course?.courseName}
                        </p>
                      </Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          {course?.courseNumber}
                        </p>
                      </Card.Subtitle>
                      <Card.Text>{course?.description}</Card.Text>
                    </Card.Body>
                    <Card.Footer style={{ textAlign: "end" }}>
                      <Button
                        size="sm"
                        style={{ backgroundColor: "none" }}
                        variant="warning"
                        onClick={() => {
                          // setShowSubCards(true);
                          setSubCardsData(course?.subCardData);
                          setCourseRelatedData(course);
                          setShow(true);
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faArrowRight}
                          size="2x"
                          style={{ width: "40px" }}
                        />
                      </Button>
                    </Card.Footer>
                  </Card>
                </div>
              );
            })
          )
        }
      </div>

      <div>
        {
          (hideMainContent) ? (
            <>
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  marginTop: 20
                }}>
                <Button variant="warning" size="sm" onClick={_goBackMainContent}>
                  Go Back
                </Button>
              </div>
            </>
          ) : (
            <></>
          )
        }
      </div>
      <div>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          size="xl"
          scrollable={true}
          centered={true}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              {courseRelatedData?.courseName + " " + courseRelatedData?.courseNumber}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {subCardData?.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    padding: 10,
                    gap: 50,
                    // width: "90%",
                    // backgroundColor: "red",
                    color: "black",
                    // boxShadow: "10px black",
                  }}
                >
                  {/* <Card>
                    <Card.Body
                      style={{
                        height: "50px",
                        backgroundColor: "#ffc107"
                      }}
                    >
                      <Card.Title>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 24,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          {courseRelatedData?.courseName + " " + courseRelatedData?.courseNumber}
                        </p>
                      </Card.Title>
                      <Card.Text></Card.Text>
                    </Card.Body>
                  </Card> */}
                  <Card>
                    <Card.Body
                      style={{
                        // height: "300px",
                      }}
                    >
                      <Card.Title>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 24,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          Course Resources
                        </p>
                      </Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          { }
                        </p>
                        <a href={courseRelatedData?.resource?.courseCatalog} target="_blank" rel="noreferrer">Course Catalog</a>
                        {/* <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          Learning Out Comes :
                        </p> */}
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "100%",
                          }}
                        >
                          <Table striped="columns">
                            <tbody>
                              <tr>
                                <td rowSpan={7} style={{ verticalAlign: "middle" }}>
                                  Learning Out Comes:
                                </td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.resource?.learningOutcomes?.[0].outcome1}</td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.resource?.learningOutcomes?.[1].outcome2}</td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.resource?.learningOutcomes?.[2].outcome3}</td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.resource?.learningOutcomes?.[3].outcome4}</td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.resource?.learningOutcomes?.[4].outcome5}</td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.resource?.learningOutcomes?.[5].outcome6}</td>
                              </tr>
                            </tbody>
                          </Table>
                          {/* {courseRelatedData?.resource?.learningOutcomes?.[0].outcome1}<br />
                          {courseRelatedData?.resource?.learningOutcomes?.[1].outcome2}<br />
                          {courseRelatedData?.resource?.learningOutcomes?.[2].outcome3}<br />
                          {courseRelatedData?.resource?.learningOutcomes?.[3].outcome4}<br />
                          {courseRelatedData?.resource?.learningOutcomes?.[4].outcome5}<br />
                          {courseRelatedData?.resource?.learningOutcomes?.[5].outcome6}<br /> */}
                        </p>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "100%",
                          }}
                        > Offering History
                          <Table striped="columns" style={{ marginTop: "2rem" }}>
                            <thead>
                              <tr>
                                <th>Sem</th>
                                <th>From</th>
                                <th>To</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[0].sem}</td>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[0].from}</td>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[0].to}</td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[1].sem}</td>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[1].from}</td>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[1].to}</td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[2].sem}</td>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[2].from}</td>
                                <td>{courseRelatedData?.resource?.offeringHistory?.[2].to}</td>
                              </tr>
                            </tbody>
                          </Table>
                          {/* {"Sem : " + courseRelatedData?.resource?.offeringHistory?.[0].sem + " From : " + courseRelatedData?.resource?.offeringHistory?.[0].from + " To : " + courseRelatedData?.resource?.offeringHistory?.[0].to}<br />
                          {"Sem : " + courseRelatedData?.resource?.offeringHistory?.[1].sem + " From : " + courseRelatedData?.resource?.offeringHistory?.[1].from + " To : " + courseRelatedData?.resource?.offeringHistory?.[1].to}<br />
                          {"Sem : " + courseRelatedData?.resource?.offeringHistory?.[2].sem + " From : " + courseRelatedData?.resource?.offeringHistory?.[2].from + " To : " + courseRelatedData?.resource?.offeringHistory?.[2].to}<br /> */}
                        </p>
                      </Card.Subtitle>
                      <Card.Text></Card.Text>
                    </Card.Body>
                  </Card>

                  <Card style={{ marginTop: "1rem" }}>
                    <Card.Body
                      style={{
                        // height: "200px",
                      }}
                    >
                      <Card.Title>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 24,

                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          Course Co-ordinator Information
                        </p>
                      </Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          {"Name : " + courseRelatedData?.coordinator?.firstName + " " + courseRelatedData?.coordinator?.lastName}
                        </p>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          {"Email : " + courseRelatedData?.coordinator?.email}
                        </p>
                        <a href={courseRelatedData?.coordinator?.d2lMasterLink} target="_blank" rel="noreferrer">D2L Master Link</a>
                      </Card.Subtitle>
                      <Card.Text></Card.Text>
                    </Card.Body>
                  </Card>

                  <Card style={{ marginTop: "1rem" }}>
                    <Card.Body
                      style={{
                        // height: "100px",
                      }}
                    >
                      <Card.Title>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 24,

                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          Permanent Schedule
                        </p>
                      </Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          <Table striped="columns">
                            <tbody>
                              <tr>
                                <td>Fall Even </td>
                                <td>Fall Odd</td>
                                <td>Sprint Even</td>
                                <td>Sprint Odd</td>
                                <td>Summer Even</td>
                                <td>Summer Odd</td>
                              </tr>
                              <tr>
                                <td>{courseRelatedData?.permSchedule?.fallEven}</td>
                                <td>{courseRelatedData?.permSchedule?.fallOdd}</td>
                                <td>{courseRelatedData?.permSchedule?.springEven}</td>
                                <td>{courseRelatedData?.permSchedule?.springOdd}</td>
                                <td>{courseRelatedData?.permSchedule?.summerEven}</td>
                                <td>{courseRelatedData?.permSchedule?.summerOdd}</td>
                              </tr>
                            </tbody>
                          </Table>
                          {/* {"Fall Even : " + courseRelatedData?.permSchedule?.fallEven + " Fall Odd : " + courseRelatedData?.permSchedule?.fallOdd + " Sprint Even : " + courseRelatedData?.permSchedule?.springEven + " Spring Odd : " + courseRelatedData?.permSchedule?.springOdd + " Summer Even : " + courseRelatedData?.permSchedule?.summerEven + " Summer Odd : " + courseRelatedData?.permSchedule?.summerOdd} */}
                        </p>
                      </Card.Subtitle>
                      <Card.Text>{ }</Card.Text>
                    </Card.Body>
                  </Card>

                  <Card style={{ marginTop: "1rem" }}>
                    <Card.Body
                      style={{
                        // height: "200px",
                      }}
                    >
                      <Card.Title>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 24,

                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          Affordable Learning Georgia
                        </p>
                      </Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: 16,
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "110%",
                          }}
                        >
                          <Table striped="columns">
                            <tbody>
                              <tr>
                                <td>Eligible</td>
                                <td>{courseRelatedData?.alg?.algEligible}</td>
                              </tr>
                              <tr>
                                <td>Latest Round</td>
                                <td>{courseRelatedData?.alg?.latestALGRound}</td>
                              </tr>
                              <tr>
                                <td>Latest Developer</td>
                                <td>{courseRelatedData?.alg?.latestDeveloper}</td>
                              </tr>
                              <tr>
                                <td>Note</td>
                                <td>{courseRelatedData?.alg?.note}</td>
                              </tr>
                              <tr>
                                <td>History Round And Developers</td>
                                <td>{courseRelatedData?.alg?.historyRoundAndDevelopers}</td>
                              </tr>
                            </tbody>
                          </Table>
                          {/* {"Eligible : " + item?.alg?.algEligible + " Latest Round : " + item?.alg?.latestALGRound + " Latest Developer : " + item?.alg?.latestDeveloper + " Note : " + item?.alg?.note} */}
                        </p>
                      </Card.Subtitle>
                      {/* <Card.Text>{"History Round And Developers : " + courseRelatedData?.alg?.historyRoundAndDevelopers}</Card.Text> */}
                    </Card.Body>
                  </Card>
                </div>
              );
            })}
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn me-3" color="danger" variant="warning" onClick={() => setShow(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default HomeScreen;
